import React, { useEffect, useState } from "react";
import "../componnetsCss/Packs.css"
import { app } from "../Firebase";
import {
  getDatabase,
  ref,
  onValue,
  update,
  limitToFirst,
} from "firebase/database";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { ToastContainer, toast } from "react-toastify";
import { Col, Container, Row } from "react-bootstrap";
import nineHundred from "../images/900.png";
import twelveHundred from "../images/1500.png";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import {
  FaBusinessTime,
  FaCalendarTimes,
  FaClock,
  FaRegCalendarTimes,
  FaTiktok,
  FaTimes,
  FaTimesCircle,
  FaVideo,
  FaYoutube,
  FaBell,
  FaWallet,
  FaWhatsapp,
  FaCheck,
  FaLock,
  FaArrowUp,
  FaShieldAlt,
  FaUser,
  FaUsers,
  FaGem
} from "react-icons/fa";
import ReactPlayer from "react-player";
import UserActive from "./UserActive";
import GiveawayParti from "./GiveawayParti";

const Packs = (props) => {
  // console.log(props.value.user)
  const user = props.value.user;
  const [showBal, setBal] = useState(Number);
  const [userid, SetUserId] = useState();
  ////// for package 1  after buy botton msg
  const [showbtnmsg, Setshowbtnmsg] = useState();
  /////// for collect button
  const [pack1CollMgs, setChk] = useState(false);
  /////// for video show hide
  const [videoShowForPack1, Setvideoshowforpack] = useState();
  ///// For Colect button Show Hide
  const [showCollect, SetshowCollect] = useState(1);
  ////// For pack 1 video url
  const [videoPack1Url, setvideoPack1Url] = useState(); //package 1 video Url
  ///////////////////////// For Pack 2
  ////////For Btn Show Hide
  const [showbtnmsgpk2, setshowbtnmsgpkb] = useState(false);
  ////////For video Show Hide For Package 2
  const [videoShowForPack2, setvideoShowForPack2] = useState();
  /////// For Collect Botton For Package 2
  const [pack2CollMsg, setpack2CollMsg] = useState(false);
  ///// For Colect button Show Hide
  const [showCollectPack2, setshowCollectPack2] = useState(1);
  const [videoUrlPack2, setvideoUrlPack2] = useState(); /// package  2 video url lick
  //// For Referal Info
  const [referalusers, setreferaluser] = useState();
  const [referalamount, setreferalamount] = useState();
  const [text, setText] = useState("");
  //// for course
  const [firstCoursev, setfirstCoursev] = useState();
  const [youtube, setYoutube] = useState(false);
  ///For tiktok
  const [secondCoursev, setsecondCoursev] = useState();
  const [tiktok, settiktok] = useState(false);

  const [name, setname] = useState();

  let currentDateTime = new Date().toISOString();
  let currentDate = new Date().getDate();
  let currentHours = new Date().getHours();
  let currentMinutes = new Date().getMinutes();
  let currentSecond = new Date().getSeconds();

  useEffect(() => {
    const readDataUser = () => {
      const db = getDatabase(app);
      const starCountRef = ref(db, user);
      onValue(starCountRef, (snapshot) => {
        const data = snapshot.val();
        const assd = data.userid;
        setname(data.username)
        setBal(data.Bal);
        SetUserId(assd);
        Setshowbtnmsg(data.Msg.pack3);
        Setvideoshowforpack(data.Packages.package3);
        setvideoPack1Url(data.URL.pack3);
        ///for pack 2
        setshowbtnmsgpkb(data.Msg.pack4);
        setvideoShowForPack2(data.Packages.package4);
        setvideoUrlPack2(data.URL.pack4);
        setreferaluser(data.AddUser.addusers);
        setreferalamount(data.AddUser.ReferalAmount);
        ///////// For Coures
        setfirstCoursev(data.Btn.Pack1Btn);
        setsecondCoursev(data.Btn.Pack2Btn);
      });
    };
    readDataUser();
  }, []);
  /////////////////////////////////// Courses
  ///////////////youtube
  setTimeout(() => {
    const checker = () => {

      if (firstCoursev == 1) {
        console.log(`hally  `);
        setYoutube(true);
      }
      if (secondCoursev == 1) {
        settiktok(true);
      }
    };
    checker();
  }, 500);

  const funcPackOne = () => {
    if (showBal >= 900) {
      const db = getDatabase(app);
      const as = ref(db, `${userid}`);
      let ass = showBal - 900;
      update(as, {
        Bal: ass,
        BuyPack3: {
          whichPackage: 900,
          andBuyTime: `date:${currentDate}=${currentHours}:${currentMinutes}:${currentSecond}`,
        },
      })
        .then((ref) => {
          const notify = () => toast.success("Package Buy Successfully");
          notify();
        })
        .catch((err) => {
          const notify = () => toast.warn("Please Deposit");
          notify();
        });

      /////for hide botton if user buy this package
      const aas = ref(db, `${userid}/Msg`);
      update(aas, {
        pack3: true,
      });

      return false;
    } else {
      toast.warn("Please Deposit");
    }
  };

  const pack1FuncForColl = () => {
    setTimeout(() => {
      setChk(true);
    }, 900000);
  };

  const collPack1Coin = () => {
    SetshowCollect(showCollect + 1);
    const db = getDatabase(app);
    const aas = ref(db, `${userid}`);
    const a = showBal + 120;
    update(aas, {
      Bal: a,
    });

    setChk(false);
    Setvideoshowforpack(false);
    setChk(false);

    const aaas = ref(db, `${userid}/Packages`);

    // const collect = showBal + 50;

    update(aaas, {
      package3: false,
      pkg3: `${currentDate}/ ${currentHours}/h.. ${currentMinutes}/m.. ${currentSecond}/s..`,
    });
  };

  /////////////////////Function For Package2
  const funcPack2ForBuy = () => {
    if (showBal >= 1500) {
      const db = getDatabase(app);
      const as = ref(db, `${userid}`);
      let ass = showBal - 1500;
      update(as, {
        Bal: ass,
        BuyPack4: {
          whichPackage2: 1500,
          andBuyTime2: `date:${currentDate}=${currentHours}:${currentMinutes}:${currentSecond}`,
        },
      })
        .then((ref) => {
          const notify = () => toast.success("Package Buy Successfully");
          notify();
          console.log(1);
        })
        .catch((err) => {
          const notify = () => toast.warn("Please Deposit");
          notify();
        });
      /////for hide botton if user buy this package
      const aas = ref(db, `${userid}/Msg`);
      update(aas, {
        pack4: true,
      });

      return false;
    } else {
      toast.warn("Please Deposit");
    }
  };
  ///////// For onStart Func in Package 2

  const pack2FuncForColl = () => {
    setTimeout(() => {
      setpack2CollMsg(true);
    }, 900000);
  };
  const collPack2Coin = () => {
    setshowCollectPack2(showCollectPack2 + 1);
    const db = getDatabase(app);
    const aas = ref(db, `${userid}`);
    const a = showBal + 200;
    update(aas, {
      Bal: a,
    });

    setpack2CollMsg(false);
    setvideoShowForPack2(false);
    setpack2CollMsg(false);

    const aaas = ref(db, `${userid}/Packages`);

    update(aaas, {
      package4: false,
      pkg4: `${currentDate}/ ${currentHours}/h.. ${currentMinutes}/m.. ${currentSecond}/s..`,
    });
  };

  const items = [
    "Bilal: (0342****87) 450Rs Withdrawal Successful.",
    "Yasir: (0320****14) 150Rs Withdrawal Successful.",
    "Mariam: (0304****62) 200Rs Withdrawal Successful.",
    "Imran: (0357****80) 200Rs Deposit Successful.",
    "Amina: (0345****29) 450Rs Withdrawal Successful.",
    "Shahzaib: (0318****95) 550Rs Withdrawal Successful.",
    "Sara: (0327****69) 350Rs Withdrawal Successful.",
    "Tariq: (0315****22) 550Rs Withdrawal Successful.",
    "Yasmin: (0320****36) 200Rs Deposit Successful.",
    "Aliya: (0321****72) 150Rs Withdrawal Successful.",
    "Ali: (0320****34) 350Rs Withdrawal Successful.",
    "Nadeem: (0312****65) 2500Rs Deposit Successful.",
    "Fatima: (0302****72) 200Rs Withdrawal Successful.",
    "Tariq: (0302****96) 450Rs Deposit Successful.",
    "Imran: (0314****85) 550Rs Withdrawal Successful.",
    "Khadijah: (0358****65) 450Rs Withdrawal Successful.",
    "Yasir: (0305****29) 950Rs Deposit Successful.",
    "Arif: (0303****47) 350Rs Withdrawal Successful.",
    "Sana: (0307****19) 150Rs Withdrawal Successful.",
    "Raza: (0313****53) 2000Rs Deposit Successful.",
    "Ahmed: (0331****65) 1000Rs Deposit Successful.",
    "Shahid: (0337****92) 200Rs Withdrawal Successful.",
    "Ameen: (0312****08) 2500Rs Deposit Successful.",
    "Zain: (0324****39) 350Rs Withdrawal Successful.",
    "Mariam: (0348****10) 450Rs Withdrawal Successful.",
    "Noreen: (0338****11) 2200Rs Deposit Successful.",
    "Sara: (0328****65) 450Rs Withdrawal Successful.",
    "Ahsan: (0321****45) 350Rs Withdrawal Successful.",
    "Khadijah: (0312****34) 200Rs Deposit Successful.",
    "Nida: (0305****14) 2000Rs Deposit Successful.",
    "Rizwan: (0333****85) 350Rs Withdrawal Successful.",
    "Zainab: (0332****54) 1800Rs Deposit Successful.",
    "Raheel: (0334****77) 750Rs Withdrawal Successful.",
    "Naima: (0347****16) 800Rs Deposit Successful.",
    "Imran: (0305****23) 600Rs Deposit Successful.",
    "Shabana: (0328****14) 450Rs Withdrawal Successful.",
    "Bilal: (0345****29) 2000Rs Deposit Successful.",
    "Tahir: (0322****34) 750Rs Withdrawal Successful.",
    "Samina: (0346****23) 1800Rs Deposit Successful.",
    "Saira: (0321****76) 750Rs Withdrawal Successful.",
    "Farhan: (0356****74) 750Rs Withdrawal Successful.",
    "Hassan: (0329****57) 150Rs Withdrawal Successful.",
    "Mariam: (0313****47) 200Rs Deposit Successful.",
    "Arif: (0334****28) 2000Rs Deposit Successful.",
    "Raza: (0329****60) 1700Rs Deposit Successful.",
    "Mustafa: (0319****48) 1100Rs Deposit Successful.",
    "Imran: (0305****23) 1500Rs Deposit Successful.",
    "Asma: (0339****03) 950Rs Deposit Successful.",
    "Waseem: (0316****95) 1800Rs Deposit Successful.",
    "Yasmin: (0347****25) 1200Rs Deposit Successful.",
    "Kamran: (0306****12) 1500Rs Deposit Successful.",
    "Farah: (0317****23) 750Rs Withdrawal Successful.",
    "Mustafa: (0305****81) 2000Rs Deposit Successful.",
    "Mehmood: (0306****59) 2100Rs Deposit Successful.",
    "Rizwan: (0317****53) 1000Rs Deposit Successful.",
    "Rabia: (0311****83) 1700Rs Deposit Successful.",
    "Tariq: (0356****74) 750Rs Withdrawal Successful.",
    "Khalid: (0305****67) 200Rs Deposit Successful.",
    "Talha: (0314****70) 1600Rs Deposit Successful.",
    "Ali: (0349****81) 750Rs Withdrawal Successful.",
    "Ahsan: (0321****45) 350Rs Withdrawal Successful.",
    "Sara: (0326****91) 1400Rs Deposit Successful.",
    "Rabia: (0308****64) 750Rs Withdrawal Successful.",
    "Ahmed: (0303****88) 150Rs Withdrawal Successful.",
    "Fatima: (0302****72) 500Rs Deposit Successful.",
    "Zain: (0351****46) 1700Rs Deposit Successful.",
    "Imran: (0357****10) 700Rs Deposit Successful.",
    "Hina: (0310****86) 350Rs Withdrawal Successful.",
    "Naveed: (0339****02) 1100Rs Deposit Successful.",
    "Bilal: (0345****29) 350Rs Withdrawal Successful.",
    "Shahzaib: (0314****55) 1400Rs Deposit Successful.",
    "Fariha: (0312****48) 1200Rs Deposit Successful.",
    "Sana: (0316****86) 2000Rs Deposit Successful.",
    "Yasir: (0313****75) 800Rs Deposit Successful.",
    "Kamran: (0344****25) 450Rs Withdrawal Successful.",
    "Rabia: (0306****44) 1600Rs Deposit Successful.",
    "Zainab: (0301****47) 750Rs Withdrawal Successful.",
    "Zubair: (0303****19) 150Rs Withdrawal Successful.",
    "Ameen: (0312****08) 2500Rs Deposit Successful.",
    "Mustafa: (0347****81) 2500Rs Deposit Successful.",
    "Shahid: (0337****92) 200Rs Withdrawal Successful.",
    "Rashid: (0335****47) 150Rs Withdrawal Successful.",
    "Farooq: (0339****02) 2500Rs Deposit Successful.",
    "Fatima: (0302****72) 500Rs Deposit Successful.",
    "Yasir: (0322****91) 550Rs Withdrawal Successful.",
    "Afsheen: (0352****63) 750Rs Deposit Successful.",
    "Kamran: (0310****72) 1500Rs Deposit Successful.",
    "Raza: (0329****60) 1700Rs Deposit Successful.",
    "Saira: (0350****92) 1700Rs Deposit Successful.",
    "Aliya: (0321****72) 150Rs Withdrawal Successful.",
    "Asma: (0329****11) 1600Rs Deposit Successful.",
    "Mariam: (0313****47) 1900Rs Deposit Successful.",
    "Sami: (0305****19) 1200Rs Deposit Successful.",
    "Zain: (0351****46) 350Rs Withdrawal Successful.",
    "Shahid: (0337****92) 200Rs Withdrawal Successful.",
    "Imran: (0357****10) 700Rs Deposit Successful.",
    "Imran: (0330****56) 650Rs Deposit Successful.",
    "Ameer: (0315****48) 1000Rs Deposit Successful.",
    "Zainab: (0332****54) 1800Rs Deposit Successful.",
    "Tariq: (0315****22) 550Rs Withdrawal Successful.",
    "Sara: (0326****91) 350Rs Withdrawal Successful.",
    "Shahzaib: (0314****55) 1400Rs Deposit Successful.",
    "Rabia: (0311****83) 1700Rs Deposit Successful.",
    "Nida: (0301****11) 750Rs Withdrawal Successful.",
    "Fatima: (0302****72) 200Rs Withdrawal Successful.",
    "Imran: (0347****30) 200Rs Deposit Successful.",
    "Shahzaib: (0314****55) 1400Rs Deposit Successful.",
    "Sana: (0316****86) 2000Rs Deposit Successful.",
    "Ayesha: (0313****75) 800Rs Deposit Successful.",
    "Raza: (0329****60) 1000Rs Deposit Successful.",
    "Ameen: (0312****08) 2500Rs Deposit Successful.",
    "Rizwan: (0333****85) 350Rs Withdrawal Successful.",
    "Fariha: (0333****28) 950Rs Deposit Successful.",
    "Kamran: (0344****21) 350Rs Withdrawal Successful.",
    "Farooq: (0312****65) 200Rs Deposit Successful.",
    "Mariam: (0312****64) 1000Rs Deposit Successful.",
    "Zubair: (0316****28) 2000Rs Deposit Successful.",
    "Zain: (0324****39) 350Rs Withdrawal Successful.",
    "Yasmin: (0301****36) 350Rs Withdrawal Successful.",
    "Afsheen: (0352****63) 750Rs Deposit Successful.",
    "Shahzaib: (0314****95) 2500Rs Deposit Successful.",
  ];

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent page reload

    // Clear the textarea by resetting the state
    setText("");
  };

  const Complain = () => {
    const db = getDatabase(app);
    const aas = ref(
      db,
      `Complain/${userid}/${currentDate}: ${currentHours}H: ${currentMinutes}M: ${currentSecond}S:`
    );

    update(aas, {
      userid: text,
    });
  };

  /// For youtube Course 's
  const firstCour = () => {
    console.log(showBal);
    if (showBal >= 277) {
      const notify = () => toast.success("Course Buy Successfully");
      notify();

      const db = getDatabase(app);

      const aas = ref(db, `${userid}`);
      const bal = showBal - 277;
      update(aas, {
        Bal: bal,
      });
      const aaas = ref(db, `${userid}/Btn`);
      update(aaas, {
        Pack1Btn: 1,
      });
    } else {
      const notify = () => toast.warn("Something Wrong");
      notify();
      console.log(`bye`);
    }
  };

  //// For Tiktok course
  const secondCour = () => {
    console.log(showBal);
    if (showBal >= 277) {
      const notify = () => toast.success("Course Buy Successfully");
      notify();
      console.log(firstCoursev);
      const db = getDatabase(app);

      const aas = ref(db, `${userid}`);
      const bal = showBal - 277;
      update(aas, {
        Bal: bal,
      });
      const aaas = ref(db, `${userid}/Btn`);
      update(aaas, {
        Pack2Btn: 1,
      });
    } else {
      const notify = () => toast.warn("Something Wrong");
      notify();
      console.log(`bye`);
    }
  };

  return (
    <div className="fintech-dashboard">
      {/* --- Top Navigation --- */}


      <main className="dashboard-body">
        <ToastContainer position="top-right" autoClose={1000} theme="dark" />

        {/* --- Premium Balance Card --- */}


        {/* --- Investment Section Title --- */}
        <div className="section-header-wrapper">
          <div className="title-container">
            <div className="line-decorator"></div>
            <h2 className="section-title">
              <FaGem className="premium-icon" />
              Premium Package
            </h2>
            <p className="section-subtitle">Earn daily profit from verified video nodes</p>
          </div>
        </div>

        {/* --- Packages Grid --- */}
        <div className="packages-container">
          <div className="packages-wrapper">

            {/* Package 1 */}
            <div className="premium-card">
              <div className="card-media-box">
                <div className="package-badge">PREMIUM</div>
                {videoShowForPack1 ? (
                  <div className="player-wrapper">
                    <ReactPlayer url={videoPack1Url} width="100%" height="100%" onStart={pack1FuncForColl} />
                  </div>
                ) : (
                  <img src={nineHundred} alt="900" className="package-img" />
                )}
              </div>
              <div className="card-body-content">
                <h3 className="pkg-title">Node <span className="price">900</span></h3>
                <div className="pkg-stats">
                  <div className="stat-row highlight">
                    <span>Total Return</span>
                    <span>3600 Rs</span>
                  </div>
                  <div className="stat-row">
                    <span>Daily Video</span>
                    <span>2 </span>
                  </div>
                  <div className="stat-row">
                    <span>Video 2</span>
                    <span>10:30-11:00am</span>
                  </div>
                  <div className="stat-row">
                    <span>Video 2</span>
                    <span>4:00-4:30pm</span>
                  </div>
                  <div className="stat-row">
                    <span>Duration</span>
                    <span>15 Minutes</span>
                  </div>
                  <div className="validity-tag">Ends in 15 Days</div>
                </div>

                {showbtnmsg ? (
                  pack1CollMgs ? (
                    <button className="collect-btn" onClick={collPack1Coin}>Collect Profit</button>
                  ) : (
                    <span className="waiting-status">⏳ Processing...</span>
                  )
                ) : (
                  <button className="buy-btn" onClick={funcPackOne}>Activate Node</button>
                )}
              </div>
            </div>

            {/* Package 2 */}
            <div className="premium-card">
              <div className="card-media-box">
                <div className="package-badge gold">PREMIUM</div>
                {videoShowForPack2 ? (
                  <div className="player-wrapper">
                    <ReactPlayer url={videoUrlPack2} width="100%" height="100%" onStart={pack2FuncForColl} />
                  </div>
                ) : (
                  <img src={twelveHundred} alt="1500" className="package-img" />
                )}
              </div>
              <div className="card-body-content">
                <h3 className="pkg-title">Node <span className="price">1500</span></h3>
                <div className="pkg-stats">
                  <div className="stat-row highlight">
                    <span>Total Return</span>
                    <span>6000 Rs</span>
                  </div>
                  <div className="stat-row">
                    <span>Daily Video</span>
                    <span>2 </span>
                  </div>
                  <div className="stat-row">
                    <span>Video 2</span>
                    <span>10:30-11:00am</span>
                  </div>
                  <div className="stat-row">
                    <span>Video 2</span>
                    <span>4:00-4:30pm</span>
                  </div>

                  <div className="stat-row">
                    <span>Duration</span>
                    <span>15 Minutes</span>
                  </div>
                  <div className="validity-tag">Ends in 15 Days</div>
                </div>

                {showbtnmsgpk2 ? (
                  pack2CollMsg ? (
                    <button className="collect-btn" onClick={collPack2Coin}>Collect Profit</button>
                  ) : (
                    <span className="waiting-status">⏳ Processing...</span>
                  )
                ) : (
                  <button className="buy-btn" onClick={funcPack2ForBuy}>Activate Node</button>
                )}
              </div>
            </div>

          </div>
        </div>

        <div className="packages-container">
          <div className="packages-wrapper">

            {/* Youtube Course Card */}
            <div className="premium-card">
              <div className="card-media-box">
                <div className="package-badge">TRENDING</div>
                <img
                  src="https://cdn.pixabay.com/photo/2024/02/10/10/08/youtube-8564483_1280.png"
                  alt="Youtube Course"
                  className="package-img"
                />
              </div>
              <div className="card-body-content">
                <h3 className="pkg-title">
                  Youtube <FaYoutube style={{ color: "#FF0000" }} />
                </h3>

                <div className="pkg-stats">
                  <div className="stat-row highlight">
                    <span>Daily Earning</span>
                    <span>10$</span>
                  </div>
                  <div className="stat-row">
                    <span><FaVideo /> Course</span>
                    <span>1 Video Only</span>
                  </div>
                  <div className="stat-row">
                    <span><FaClock /> Length</span>
                    <span>50 Minutes</span>
                  </div>
                  <div className="stat-row">
                    <span>Price</span>
                    <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>0.99$</span>
                  </div>
                </div>

                <p className="description-text">
                  Learn how to make money on YouTube – start earning today!
                </p>

                {!youtube ? (
                  <button className="buy-btn" onClick={firstCour}>
                    View Now
                  </button>
                ) : (
                  <a href="https://www.youtube.com/watch?v=6zn5j1TBBwss" className="visit-link-btn">
                    Visit YouTube
                  </a>
                )}
              </div>
            </div>

            {/* Tiktok Course Card */}
            <div className="premium-card">
              <div className="card-media-box">
                <div className="package-badge gold">TRENDING</div>
                <img
                  src="https://c0.wallpaperflare.com/preview/883/360/873/ecommerce-dropshipping-concept-oberlo.jpg"
                  alt="Tiktok Course"
                  className="package-img"
                />
              </div>
              <div className="card-body-content">
                <h3 className="pkg-title">
                  Tiktok <FaTiktok />
                </h3>

                <div className="pkg-stats">
                  <div className="stat-row highlight">
                    <span>Daily Earning</span>
                    <span>15.5$</span>
                  </div>
                  <div className="stat-row">
                    <span><FaVideo /> Course</span>
                    <span>2 Videos Only</span>
                  </div>
                  <div className="stat-row">
                    <span><FaClock /> Length</span>
                    <span>20 Minutes</span>
                  </div>
                  <div className="stat-row">
                    <span>Price</span>
                    <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>0.99$</span>
                  </div>
                </div>

                <p className="description-text">
                  Learn how to make money on Tiktok – start earning today!
                </p>

                {!tiktok ? (
                  <button className="buy-btn" onClick={secondCour}>
                    View Now
                  </button>
                ) : (
                  <a href="https://www.youtube.com/watch?v=16bxv7BLk2o&list=PLzmpNLhY7L7K0jCgj_9YXl9BBQfR-KSM-" className="visit-link-btn">
                    Visit YouTube
                  </a>
                )}
              </div>
            </div>

          </div>
        </div>
        {/* --- Support & Complaint Section --- */}
        <div className="premium-stats-container">
          <div className="trusted-main-card" style={{ marginTop: '20px' }}>
            <h3 className="pkg-title" style={{ textAlign: 'center' }}>Report an Issue</h3>
            <form onSubmit={handleSubmit}>
              <textarea
                className="styled-textarea"
                placeholder="Explain your problem..."
                value={text}
                onChange={(e) => setText(e.target.value)}
                style={{ width: '100%', background: '#0b0e14', border: '1px solid #3b82f6', color: '#fff', borderRadius: '15px', padding: '15px', marginBottom: '15px' }}
              />
              <button type="submit" className="buy-btn" onClick={Complain}>Submit Complaint</button>
            </form>
          </div>
        </div>

      </main>
    </div>
  );
};

export default Packs;
